module.exports = __webpack_public_path__ + "static/media/image-gallery-2.28ca2d41.jpg";